import React from 'react';
import './accessDenied.less';
import {useTranslation} from "react-i18next";

const AccessDenied = () => {

    const {t} = useTranslation()

    return(
        <div className="access-denied d-flex flex-column align-items-center justify-content-center">
            <div className="title">{t("lbl.ACCESS_DENIED","Access Denied")}!</div>
            <div className="description">{t("lbl.NOT_AUTHORIZED","You are not authorized to view this page")}.</div>
        </div>
    );

}

export default AccessDenied;




